/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "ca-central-1",
  aws_cloud_logic_custom: [
    {
      name: "AdminQueries",
      endpoint:
        "https://92gv50tpti.execute-api.ca-central-1.amazonaws.com/prcan",
      region: "ca-central-1",
    },
    {
      name: "adminapi",
      endpoint:
        "https://ratums2l43.execute-api.ca-central-1.amazonaws.com/prcan",
      region: "ca-central-1",
    },
    {
      name: "auditapi",
      endpoint:
        "https://gf80gh4q5c.execute-api.ca-central-1.amazonaws.com/prcan",
      region: "ca-central-1",
    },
    {
      name: "bookingapi",
      endpoint:
        "https://0ftxk450nj.execute-api.ca-central-1.amazonaws.com/prcan",
      region: "ca-central-1",
    },
    {
      name: "changeuserrole",
      endpoint:
        "https://h9bpl9zaqh.execute-api.ca-central-1.amazonaws.com/prcan",
      region: "ca-central-1",
    },
    {
      name: "integrationapi",
      endpoint:
        "https://fhq05q1xnj.execute-api.ca-central-1.amazonaws.com/prcan",
      region: "ca-central-1",
    },
    {
      name: "mapdirection",
      endpoint:
        "https://wynt4p820c.execute-api.ca-central-1.amazonaws.com/prcan",
      region: "ca-central-1",
    },
    {
      name: "messaging",
      endpoint:
        "https://hd0yvfkbvf.execute-api.ca-central-1.amazonaws.com/prcan",
      region: "ca-central-1",
    },
    {
      name: "promoapi",
      endpoint:
        "https://dirq9n6037.execute-api.ca-central-1.amazonaws.com/prcan",
      region: "ca-central-1",
    },
    {
      name: "recurringBookingsApi",
      endpoint:
        "https://vw10w4tvg0.execute-api.ca-central-1.amazonaws.com/prcan",
      region: "ca-central-1",
    },
    {
      name: "redirect",
      endpoint:
        "https://isoprmxx11.execute-api.ca-central-1.amazonaws.com/prcan",
      region: "ca-central-1",
    },
    {
      name: "s3filemgmt",
      endpoint:
        "https://3woawjq04b.execute-api.ca-central-1.amazonaws.com/prcan",
      region: "ca-central-1",
    },
    {
      name: "searchapi",
      endpoint:
        "https://ia2vsclisc.execute-api.ca-central-1.amazonaws.com/prcan",
      region: "ca-central-1",
    },
    {
      name: "sendsesemail",
      endpoint:
        "https://00bwptaq29.execute-api.ca-central-1.amazonaws.com/prcan",
      region: "ca-central-1",
    },
    {
      name: "sendtwilioemail",
      endpoint:
        "https://u2yr1s6axd.execute-api.ca-central-1.amazonaws.com/prcan",
      region: "ca-central-1",
    },
    {
      name: "serviceManagement",
      endpoint:
        "https://s7zg4f20hd.execute-api.ca-central-1.amazonaws.com/prcan",
      region: "ca-central-1",
    },
    {
      name: "stripechargecard",
      endpoint:
        "https://7nlloiv53i.execute-api.ca-central-1.amazonaws.com/prcan",
      region: "ca-central-1",
    },
    {
      name: "stripeconnect",
      endpoint:
        "https://hiurojvdb7.execute-api.ca-central-1.amazonaws.com/prcan",
      region: "ca-central-1",
    },
    {
      name: "stripesavecard",
      endpoint:
        "https://dd2werehub.execute-api.ca-central-1.amazonaws.com/prcan",
      region: "ca-central-1",
    },
    {
      name: "twiliosmsin",
      endpoint:
        "https://x5exn94rpf.execute-api.ca-central-1.amazonaws.com/prcan",
      region: "ca-central-1",
    },
    {
      name: "userManagement",
      endpoint:
        "https://uai3qabym3.execute-api.ca-central-1.amazonaws.com/prcan",
      region: "ca-central-1",
    },
    {
      name: "virtualmeeting",
      endpoint:
        "https://ltk40sp6k0.execute-api.ca-central-1.amazonaws.com/prcan",
      region: "ca-central-1",
    },
    {
      name: "MB-rest-api",
      endpoint:
        "https://1b285c8hia.execute-api.ca-central-1.amazonaws.com/prodcan",
      region: "ca-central-1",
    },
  ],
  aws_appsync_graphqlEndpoint:
    "https://4eoer6tulvfehpenrrvdhh6pqq.appsync-api.ca-central-1.amazonaws.com/graphql",
  aws_appsync_region: "ca-central-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_cognito_identity_pool_id:
    "ca-central-1:c5329a8c-e5a7-4c77-8daf-28b963330d9b",
  aws_cognito_region: "ca-central-1",
  aws_user_pools_id: "ca-central-1_5EiIDqwy4",
  aws_user_pools_web_client_id: "nvrhit17hdhqo9kgn16vk0au5",
  oauth: {},
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  aws_content_delivery_bucket: "marketbox-20190726012602-hostingbucket-prcan",
  aws_content_delivery_bucket_region: "ca-central-1",
  aws_content_delivery_url:
    "http://marketbox-20190726012602-hostingbucket-prcan.s3-website.ca-central-1.amazonaws.com",
  aws_user_files_s3_bucket: "marketboxproviderpics-prcan",
  aws_user_files_s3_bucket_region: "ca-central-1",
};

export default awsmobile;
